import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import FormHelperText from "@material-ui/core/FormHelperText";
import { connect, getIn } from "formik";

const FormFieldError = ({ name, formik }) => {
  const [error, setError] = useState(null);
  const isFirst = useRef(true);

  useEffect(
    () => {
      if (!isFirst.current) {
        setError(getIn(formik.errors, name));
      }
      isFirst.current = false;
    },
    [formik.errors, name],
  );

  return error ? <FormHelperText error>{error}</FormHelperText> : null;
};

FormFieldError.propTypes = {
  /**
   * Nombre del input
   */
  name: PropTypes.string.isRequired,
};

export default connect(FormFieldError);
